// extracted by mini-css-extract-plugin
export default {"editContainer":"_fcc627fb","wrapper":"_8bd4f213","paragraph":"_4bbf2cce","pen":"_6c0f63db","aboutExpanded":"_e4600a4a"};